module.exports = {"TXTWCL_N0_vs_N1":{"id":"TXTWCL_N0_vs_N1","defaultMessage":"{0} vs {1}"}}